import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  IncrementalDeliveryProtocol_V0_1_instance = new (IncrementalDeliveryProtocol())('V0_1', 0);
  IncrementalDeliveryProtocol_V0_2_instance = new (IncrementalDeliveryProtocol())('V0_2', 1);
}
var IncrementalDeliveryProtocol_V0_1_instance;
var IncrementalDeliveryProtocol_V0_2_instance;
var IncrementalDeliveryProtocolClass;
function IncrementalDeliveryProtocol() {
  if (IncrementalDeliveryProtocolClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'IncrementalDeliveryProtocol');
    IncrementalDeliveryProtocolClass = $;
  }
  return IncrementalDeliveryProtocolClass;
}
function IncrementalDeliveryProtocol_V0_1_getInstance() {
  static_init();
  return IncrementalDeliveryProtocol_V0_1_instance;
}
//region block: exports
export {
  IncrementalDeliveryProtocol_V0_1_getInstance as IncrementalDeliveryProtocol_V0_1_getInstancefhanbu89c1sm,
};
//endregion

//# sourceMappingURL=IncrementalDeliveryProtocol.mjs.map
